import { html } from "../../render";
import { attr, cn, spreadAttrs } from "../../utils";
export const LP_GRID_VARIANTS = ["1up", "2up", "3up", "4up", "2-1", "1-2"];
export const LP_GRID_GAPS = ["none", "sm", "base", "lg"];
const rootManagedAttrs = ["data-lp-component", "class", "data-variant", "data-gap", "data-mobile-dividers"];
const itemManagedAttrs = ["class", "data-expanded"];
function LpGridRoot({ children, variant = "2up", gap = "base", mobileDividers = false, className, attributes, }) {
    return html `
        <div
            data-lp-component="Grid"
            class="${cn("lp-grid", className, attributes?.class)}"
            data-variant="${variant}"
            data-gap="${gap}"
            ${attr("data-mobile-dividers", mobileDividers)}
            ${spreadAttrs(attributes, { omit: rootManagedAttrs })}
        >${children}</div>
    `;
}
function LpGridItem({ children, expanded = false, className, attributes, }) {
    return html `
        <div
            class="${cn("lp-grid_item", className, attributes?.class)}"
            ${attr("data-expanded", expanded)}
            ${spreadAttrs(attributes, { omit: itemManagedAttrs })}
        >${children}</div>
    `;
}
export const LpGrid = {
    Root: LpGridRoot,
    Item: LpGridItem,
};
